import React, { useState, useEffect } from 'react';
import "rc-pagination/assets/index.css";
import '../../../DataTable.css';

function ReportTable() {
  const itemsPerPage = 10;
  const [data, setAllData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  // Calculate total number of pages
  const totalPages = Math.ceil(data.length / itemsPerPage);

  // Calculate start and end index of current page
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  // Get current page data
  const currentData = data.slice(startIndex, endIndex);

  useEffect(() => {
    loadcategory();
  }, []);

  const loadcategory = () => {
    fetch("https://apimenu3.haikutheasiankitchen.com/index.php/Api/users", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.data !== "") {
          const data = result.data;
          setAllData(data);
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const renderPageNumbers = () => {
    const pages = [];
    let startPage, endPage;
    if (totalPages <= 7) {
      startPage = 1;
      endPage = totalPages;
    } else {
      if (currentPage <= 4) {
        startPage = 1;
        endPage = 7;
      } else if (currentPage + 3 >= totalPages) {
        startPage = totalPages - 6;
        endPage = totalPages;
      } else {
        startPage = currentPage - 3;
        endPage = currentPage + 3;
      }
    }
    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <button
          className={`paginationCategory ${currentPage === i ? 'active' : ''}`}
          key={i}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </button>
      );
    }
    return pages;
  };

  return (
    <>
      <style>{`
        @media (max-width: 768px) {
          .table-responsive1 {
            display: flex;
            width: 100%;
            -webkit-overflow-scrolling: touch;
            overflow-x: auto;
            flex-wrap: wrap;
          }
        }
        .paginationCategory {
          margin: 0 5px;
        }
        .paginationCategory.active {
          font-weight: bold;
        }
      `}</style>
      <div className="col-12">
        <div className="ms-panel">
          <div className="ms-panel-header">
            <div className="container">
              {/* <div className="row">
                <div className="col-md-10">
                  <h6>Users Report</h6>
                </div>
              </div> */}
               <div class="row"><div class="col-md-10"><h6>Users Report</h6></div><div class="col-md-2"><a href="/add-Users"><button class="addcategory" fdprocessedid="k3s5zg">Add User</button></a></div></div>
            </div>
          </div>
          <div className="ms-panel-body">
            <div className="table-responsive1">
              <table className="table table-hover thead-primary">
                <thead>
                  <tr>
                    <td>User Name</td>
                    <td>Email</td>
                    <td>Phone Number</td>
                    <td>Date</td>
                  </tr>
                </thead>
                <tbody>
                  {currentData.map((data, i) => (
                    <tr key={i}>
                      <td>{data.user_name}</td>
                      <td>{data.email}</td>
                      <td>{data.phone_number}</td>
                      <td>{data.date}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="pagination">
                <button className='addcategory'
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  Previous
                </button>
                {renderPageNumbers()}
                <button className='addcategory'
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ReportTable;
